module.exports = __webpack_public_path__ + "imgs/aa490c2b3566075a63e8c6331657dc6e.jpg";